'use client';

import React, { useEffect, useState } from 'react';

export default function TrackImage() {
  const [image, setImage] = useState<string | null>(null);
  useEffect(() => {
    const url = new URL(window.location.href);
    const fullUrl = url.toString();
    const { origin } = url;
    setImage(`${origin}/error-image?url=${fullUrl}`);
  }, []);
  // eslint-disable-next-line @next/next/no-img-element
  return image ? <img src={image} alt="" style={{ display: 'none' }} /> : null;
}
